var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"f-icon-edit",on:{"click":_vm.edit}},[_c('img',{staticClass:"f-icon-edit-img",attrs:{"src":_vm.icon}}),_c('span',{staticClass:"f-icon-edit-word"},[_vm._v("编辑")])])}
var staticRenderFns = []

export { render, staticRenderFns }